import { Component, OnInit } from '@angular/core';
import { IaudienceDesignerUrlDto } from '../../models/IAudienceDesignerUrlDTO';
import { Utils } from '../../Utils';
import { FezaDataService } from '../../services/fezadata.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../services/auth-service.service';
@Component({
    selector: 'redirector',
    templateUrl: './redirector.component.html',
    styleUrls: ['./redirector.component.css']
})
export class RedirectorComponent implements OnInit {
    redirectModel: IaudienceDesignerUrlDto;
    redirectBidId: string;
    buttonsClickable: boolean;

    constructor(private spinner: NgxSpinnerService, private fezaService: FezaDataService, private auth: AuthService) { }

    ngOnInit() {
        this.redirectModel = {
            ActiveDirectoryUserName: this.auth.User,
            UserRoles: []
        };
        this.buttonsClickable = false;
    }

    onADRedirectByBidId() {
        var correlationId = Utils.generateUUID();
        this.spinner.show();
        this.fezaService.AdRedirectByBidId(this.redirectModel, this.redirectBidId, correlationId).subscribe(res => {
            this.spinner.hide();
            window.open(res.audienceDesignerUrl, '_blank');
        })
    }

    onFizzyRedirectByBidId() {
        var path = window.location.origin + "/#/response?bidId=" + this.redirectBidId;
        window.open(path, '_blank');
        //angular way but can't open in a new tab
        //this.router.navigate(['/response'], { queryParams: { bidId: this.redirectBidId } });
    }

    checkBidExists() {
        this.fezaService.CheckBidExists(this.redirectBidId).subscribe(resp => {
            console.log(resp);
            this.buttonsClickable = resp;
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/components/redirector/redirector.component.ts